// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2uj3j","fileBtn":"File_fileBtn__3Qtd-","closeBtn":"File_closeBtn__3HFk5","fileSelected":"File_fileSelected__1o3ew","disabled":"File_disabled__qg8ya"};